import { z } from 'zod';
import { defineListQuery } from './list-query.schemas';

/**
 * `GET /dispatch/board/trips` (gitaumoses4/chukua#55): the trips on the dispatch board, newest dispatch first. Which trips belong is the
 * server's rule (under way, or dispatched since the start of the company's day), so the query carries paging only.
 */
export const tripBoardQuerySchema = defineListQuery({
  sortFields: ['dispatchedAt'],
  defaultSort: { sort: 'dispatchedAt', order: 'desc' },
});
export type TripBoardQuery = z.infer<typeof tripBoardQuerySchema>;
